export default __webpack_public_path__ + "static/media/img-0428-hungary-full-face.efc7e9b6.png";